module.exports = __webpack_public_path__ + "static/media/crackpedia_screenshot.096a83e3.webp";